import { ACTIONS, ADDONS, COOKIES } from '../constants';
import { getParsedCookie, setStringifiedCookie } from '../utils/cookieHelpers';

// initialize with cookie passed from pricing page
const getInitialState = () => {
  const parsedCookie = getParsedCookie(COOKIES.SELECTED_PACKAGES);
  return {
    [ADDONS.DEDICATED_IP]:
      parsedCookie && parsedCookie.addons && parsedCookie.addons[ADDONS.DEDICATED_IP] ?
        1 :
        0,
    [ADDONS.EASE]:
      parsedCookie && parsedCookie.addons && parsedCookie.addons[ADDONS.EASE] ?
        parsedCookie.addons[ADDONS.EASE] :
        3,
  };
};

const updateCookie = (newState) => {
  const parsedCookie = getParsedCookie(COOKIES.SELECTED_PACKAGES);
  parsedCookie.addons = newState;
  setStringifiedCookie(COOKIES.SELECTED_PACKAGES, parsedCookie);
};

const addOns = (state = getInitialState(), action) => {
  switch (action.type) {
    case ACTIONS.ADD_ADDON: {
      const newState = {
        ...state,
        ...action.addons,
      };
      updateCookie(newState);
      return newState;
    }
    case ACTIONS.REMOVE_ADDON: {
      const newState = {
        ...state,
        [action.addon.type]: 0,
      };
      updateCookie(newState);
      return newState;
    }
    default:
      return state;
  }
};

export default addOns;



// WEBPACK FOOTER //
// ./src/reducers/addOns.js